import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'debug',
    standalone: false,
})
export class DebugPipe<T> implements PipeTransform {
    transform(value: T): T {
        console.log(value);
        return value;
    }
}
